<div class="drilldown-toggle-chart-container" *ngIf="displayedChartData" [ngClass]="chartSize">
  <div class="drilldown-toggle-chart-header" [ngClass]="{ 'justify-end': !legendIsVisible }">
    <drilldown-toggle-chart-legend
      *ngIf="legendIsVisible"
      [legends]="displayedChartData.legendValues"
      [size]="chartSize"
    ></drilldown-toggle-chart-legend>
    <toggle
      class="drilldown-toggle-chart-toggle"
      *ngIf="toggleIsVisible"
      [labels]="toggleLabels"
      [checked]="toggleIsChecked"
      (toggleClick)="onToggleClick()"
    ></toggle>
  </div>

  <ng-container *ngIf="displayedChartData.type === 'bar'">
    <chart
      [field]="chartSize === 'small' ? '' : displayedChartData.fieldFilter"
      [filterService]="filterService"
      [sortedData]="displayedChartData.values"
      [chartOption]="bar"
      [kpiChartSize]="chartSize"
      [kpiOnTrack]="displayedChartData.onTrack"
      [kpiOnTarget]="displayedChartData.onTarget"
      [isPercent]="displayedChartData.config?.isPercent ?? false"
      [showAllKeys]="chartSize === 'small' ? false : true"
      [kpiAxisKeysShownDefault]="displayedChartData.yAxisLabelCount?.[chartSize]"
      [kpiXAxisLabel]="displayedChartData.xAxisLabel"
      [kpiChartIdentifier]="displayedChartData.identifier"
      [includeToggleInHeightCalculation]="true"
      [hasXaxisAggLabel]="displayedChartData.hasXAxisAggLabel"
    >
    </chart>
  </ng-container>

  <ng-container *ngIf="displayedChartData.type === 'pie'">
    <chart
      [sortedData]="displayedChartData.values"
      [field]="chartSize === 'small' ? '' : displayedChartData.fieldFilter"
      [filterService]="filterService"
      [chartOption]="pie"
      [kpiChartSize]="chartSize"
      [colorMap]="colorMap"
      [isPercent]="displayedChartData.config?.isPercent ?? false"
      [showAllKeys]="true"
      [kpiChartIdentifier]="displayedChartData.identifier"
    ></chart>
  </ng-container>

  <ng-container *ngIf="displayedChartData.type === 'groupedBar'">
    <grouped-bar-chart
      [field]="chartSize === 'small' ? '' : displayedChartData.fieldFilter"
      [filterService]="filterService"
      [sortedData]="displayedChartData.values"
      [chartOption]="groupedBar"
      [kpiChartSize]="chartSize"
      [kpiOnTrack]="displayedChartData.onTrack"
      [kpiOnTarget]="displayedChartData.onTarget"
      [isPercent]="displayedChartData.config?.isPercent ?? false"
      [showAllKeys]="chartSize === 'small' ? false : true"
      [kpiAxisKeysShownDefault]="displayedChartData.yAxisLabelCount?.[chartSize]"
      [kpiXAxisLabel]="displayedChartData.xAxisLabel"
      [kpiChartIdentifier]="displayedChartData.identifier"
      [includeToggleInHeightCalculation]="true"
    >
    </grouped-bar-chart>
  </ng-container>
</div>
